import api from "../axiosInstance";

export const createMemorial = async (memorialData) => {
    const response = await api.post("/memorials", memorialData);
    return response.data;
};

export const getUserMemorials = async () => {
    const response = await api.get("/memorials");
    return response.data;
};

export const getMemorialById = async (memorialId) => {
    const response = await api.get(`/memorials/${memorialId}`);  // ✅ FIX
    return response.data;
};

export const updateMemorial = async (memorialId, memorialData) => {
    const response = await api.put(`/memorials/${memorialId}`, memorialData);  // ✅ FIX
    return response.data;
};

export const deleteMemorial = async (memorialId) => {
    const response = await api.delete(`/memorials/${memorialId}`);  // ✅ FIX
    return response.data;
};

export const togglePublish = async (memorialId) => {
    const response = await api.post(`/memorials/${memorialId}/toggle-publish`);  // ✅ FIX
    return response.data;
};

// ========== PUBLIC ENDPOINT (NO AUTH) ==========

export const getPublicMemorial = async (qrCode) => {
    const response = await api.get(`/q/${qrCode}`);  // ✅ FIX
    return response.data;
};